import { queryOptions } from "@tanstack/react-query";
import { SetErrorMessageType } from "@/app/providers/ReactContextProvider/types";
import { QUERY_KEYS, STALE_TIME_SHORT } from "@/common/api/constants";
import { profileFetcher } from "@/entities/profile/api/profileFetcher";

interface Props {
  token: string;
  setErrorMessage: SetErrorMessageType;
  refetchOnWindowFocus?: boolean;
}

export const getProfileQueryOption = ({
  token,
  setErrorMessage,
  refetchOnWindowFocus = true,
}: Props) =>
  queryOptions({
    queryKey: [QUERY_KEYS.FETCH_PROFILE, token, setErrorMessage],
    queryFn: () => profileFetcher({ token, setErrorMessage }),
    enabled: !!token,
    staleTime: STALE_TIME_SHORT,
    refetchOnWindowFocus,
  });
